import { RootState } from 'store';
import { IStreetsResponse } from 'types';

export const getStreetsSelector = (store: RootState): IStreetsResponse | null => store.streets.data || null;

export const getStreetsIsLoadingSelector = (store: RootState): boolean => store.streets.isLoading;
